// Copyright (c) 2022 by Move Closer

import {
  ApiConnectorType,
  AppModule,
  Authentication,
  AuthProvider,
  AuthService,
  AuthServiceType,
  Container, DateTime, IConnector,
  Interfaces,
  Module,
  WindowService,
  WindowType
} from '@movecloser/front-core'

import { DrawerType, IDrawer } from '../shared/contracts/services'
import { GraphQlConnectorType, GraphQLMiddleware, IGraphQL } from '../../contexts'

import { authConfig } from './config/auth'
import { AuthControl, AuthGraphQLMiddleware, AuthGraphQLMiddlewareType } from './services'
import { AuthControlServiceType, IAuthControl } from './contracts'
import { authQueries } from './config/queries'
import { drawersRegistry } from './config/modals'
import { routesFactory as routes } from './routes'
import { storeFactory as state } from './store'
import { resources } from './config/resources'
import { LoyaltyServiceType } from '../loyalty/contracts/services'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
@AppModule({
  name: 'auth',
  providers: () => (bind: Interfaces.Bind) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    bind<Authentication<any>>(AuthServiceType).toDynamicValue((context: Interfaces.Context) => {
      return new AuthService(
        authConfig,
        context.container.get<WindowService>(WindowType),
        new DateTime()
      )
    }).inSingletonScope()

    bind<GraphQLMiddleware>(AuthGraphQLMiddlewareType).toDynamicValue((context) => {
      return new AuthGraphQLMiddleware(
        context.container.get<AuthProvider>(AuthServiceType)
      )
    })

    bind<IAuthControl>(AuthControlServiceType).toDynamicValue((context) => {
      return new AuthControl(
        context.container.get(GraphQlConnectorType),
        context.container.get(ApiConnectorType),
        context.container.get(LoyaltyServiceType)
      )
    }).inSingletonScope()
  },
  boot (container: Container) {
    const drawerConnector = container.get<IDrawer>(DrawerType)
    drawerConnector.register(drawersRegistry)

    const connector: IConnector = container.get(ApiConnectorType)
    connector.useResources(resources)

    const graph = container.get<IGraphQL>(GraphQlConnectorType)
    graph.useMiddlewares(container.get(AuthGraphQLMiddlewareType))
    graph.useQueries(authQueries)
  },
  routes,
  state
})
export class AuthModule extends Module {
}
